import { useQuery } from 'react-query';
import chatApi from '../../api/chatApi';

const usePointsOfView = (inspectionsideid: string | undefined, partofbodyid: string | undefined, inspectionmethodid: string | undefined) => {
  const queryResult = useQuery(
    ['usePointsOfView', inspectionsideid, partofbodyid, inspectionmethodid],
    () => {
      return chatApi.getPointsOfView(inspectionsideid!!, partofbodyid!!, inspectionmethodid!!).then(it => it.result);
    },
    { enabled: !!inspectionsideid && !!partofbodyid && !!inspectionmethodid }
  );

  return queryResult;
};

export default usePointsOfView;
